<template>
    <component
        :is="componentName"
        :menu-obj="items"
        :messages="messages"
    />
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'vue-menu',
    data() {
        return {
            componentName: this.getComponentName(),
            menu: this.result
        }
    },
    computed: {
        ...mapState({
            items: ({results}) => results?.menus?.mainMenu.items,
            messages: ({results}) => results?.messages,
        }),
    },
    methods: {
        getComponentName() {
            return window.innerWidth < 992 ? 'vue-menu-mobile' : 'vue-menu-desktop';
        },
        changeComponentName() {
            this.componentName = this.getComponentName();
        }
    },
    mounted() {
        window.addEventListener('resize', this.changeComponentName);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.changeComponentName);
    },
}
</script>